export default "__VITE_ASSET__ywEQ36iE__"